"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_CREDENTIAL_SECTION = exports.UPDATE_MEMBERSHIP = void 0;
exports.UPDATE_MEMBERSHIP = `
	mutation updateMembership($membershipId: String, $status: String){
		updateMembership(membershipId: $membershipId, status: $status) 
	}
`;
exports.UPDATE_CREDENTIAL_SECTION = `
	mutation updateCredentialOrSection($productType: String, $productSku: String, $status: String){
		updateCredentialOrSection(productType: $productType, productSku: $productSku, status: $status) 
	}
`;
//# sourceMappingURL=membership-queries.js.map